import { createStorageObjectItemContext } from "conference/storageObjectItemManager";
import { conferenceLocalStorage } from "conference/tools";
import { defaultSelfVideoDialogSettings } from "./tools";

export const SelfVideoDialogSettingsContext = createStorageObjectItemContext(
    conferenceLocalStorage,
    "selfVideoDialogSettings",
    defaultSelfVideoDialogSettings
);

export const useSelfVideoDialogSettings = SelfVideoDialogSettingsContext.getterHook;
